import React, { useRef } from 'react';
var VeltAutocompleteTool = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-autocomplete-tool", { ref: ref }, children));
};
export default VeltAutocompleteTool;
